import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { DELETE_IMAGES } from './constants';
import {
  DeleteImagesDataActionTypes,
  DeleteImagesError,
  DeleteImagesState,
  DeleteImagesSuccess,
} from './types';

const initialState: DeleteImagesState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: DeleteImagesDataActionTypes,
  ): DeleteImagesState => {
    switch (action.type) {
      case DELETE_IMAGES + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case DELETE_IMAGES + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as DeleteImagesSuccess).payload;
        break;
      }
      case DELETE_IMAGES + FAILURE: {
        draft.status = rejected;
        draft.error = (action as DeleteImagesError).error;
        break;
      }
      case DELETE_IMAGES + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
